<template>
  <div class="app-header"></div>
  <router-view :key="fullPath"></router-view>
  <chat-widget />
</template>

<script setup lang="ts">
import {watch, provide} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

import {useInitPresets} from "@/app/providers/axios";

import ChatWidget from '@/widgets/ChatWidget';

import {AppPages, AppRoutes, EAppProviders} from "@/app/providers";
import {isProd} from "@/shared/lib/utils/environment";

const {locale} = useI18n();

const {initAuthPresets} = useInitPresets()
const {fullPath} = useRoute();

initAuthPresets()

provide(EAppProviders.AppRoutes, AppRoutes);
provide(EAppProviders.AppPages, AppPages);

watch(locale, (val) => {
  document.documentElement.lang = val === 'kz' ? 'kk' : val;
});

if (!isProd()) {
  const meta = document.createElement('meta');
  meta.name = 'google-site-verification';
  meta.content = 'uTNKcRws_L6-z_GEdPHBA61P8n1woyFCJOCNnsy0EH4';
  document.head.appendChild(meta);
}
</script>

<style>
</style>